{
  "lib_calendar": {
    "appointment-cancellation-dialog": {
      "buttons": {
        "back": "Quay lại",
        "cancel": "Hủy lịch hẹn",
        "close": "Đóng",
        "next": "Tiếp"
      },
      "text": {
        "title": "Hủy lịch hẹn",
        "description": "Bạn có thể nói rõ hơn tại sao bạn muốn hủy lịch hẹn không?",
        "appointment-cancelled-successfully": "Lịch hẹn đã được hủy thành công!",
        "block_customer": "Bạn có muốn chặn khách hàng này không?",
        "message_to_customer": "Tin nhắn gửi cho khách hàng",
        "no": "KHÔNG",
        "no_show": "Khách hàng này không xuất hiện",
        "not_show_up": "Khách hàng này đã không xuất hiện trong {{ total }} lịch hẹn trước đây.",
        "not_show_up_first_time": "Đây là lần đầu tiên khách hàng này không xuất hiện.",
        "reason": "Lý do của bạn",
        "reason-better-deal": "Tôi đã tìm thấy một tiệm khác tốt hơn",
        "reason-mistake": "Tôi đã đổi ý hoặc vô tình đặt nhầm",
        "reason-other": "Lý do khác",
        "reason-salon-asked-to-cancel": "Tiệm yêu cầu tôi hủy lịch hẹn",
        "reason-unforeseen-circumstance": "Vì hoàn cảnh bất khả kháng nên tôi phải hủy hẹn",
        "yes": "CÓ"
      }
    },
    "appointment-chat-box": {
      "text": {
        "chat-with": "Chat với {{name}}",
        "customer": "khách hàng",
        "message": "Tin nhắn của bạn",
        "salon": "tiệm"
      }
    },
    "appointment-confirmation-dialog": {
      "buttons": {
        "cancel": "Hủy",
        "confirm-and-book": "Xác nhận và đặt",
        "confirm-and-update": "Cập nhật"
      },
      "text": {
        "title": "Xác nhận lịch hẹn",
        "book-successfully": "Lịch hẹn của bạn đã được đặt thành công",
        "update-successfully": "Lịch hẹn của bạn đã được cập nhật thành công"
      }
    },
    "appointment-details": {
      "text": {
        "serve-by-staff": "Phục vụ bởi {{staff}}",
        "staff_selected_by_customer": "Nhân viên được khách hàng lựa chọn",
        "total": "Tổng cộng"
      }
    },
    "appointment-details-card": {
      "buttons": {
        "checkin": "CHECK IN"
      },
      "text": {
        "appointment-canceled-by-salon": "Lịch hẹn đã bị hủy bởi tiệm",
        "appointment-canceled-by-you": "Lịch hẹn đã bị bạn hủy",
        "status": "Trạng thái"
      }
    },
    "appointment-details-dialog": {
      "buttons": {
        "back": "Quay lại",
        "edit": "Sửa lịch hẹn"
      },
      "text": {
        "appointment_history": "Lịch sử lịch hẹn",
        "edit_profile": "Chỉnh sửa hồ sơ",
        "more_about_customer": "Thông tin về khách hàng này",
        "Visit history": "Lịch sử ghé thăm"
      }
    },
    "appointment-details-page": {
      "buttons": {
        "cancel": "Hủy lịch hẹn"
      },
      "text": {
        "creation_time": "Ngày tạo",
        "last_update": "Cập nhật"
      }
    },
    "appointment-form": {
      "text": {
        "customer-selection": "Lựa chọn khách hàng",
        "note": "Ghi chú",
        "rwg_appointment_hint": "Không thể chỉnh sửa dịch vụ của lịch hẹn Google",
        "service-selection": "Lựa chọn dịch vụ",
        "staff-cannot-serve-any-hint": "Nhân viên được chọn không thể phục vụ bất kỳ dịch vụ nào đã chọn. Hãy cân nhắc lựa chọn nhân viên khác!",
        "staff-cannot-serve-all-hint": "Nhân viên được chọn không thể phục vụ tất cả các dịch vụ đã chọn. Một số trong số đó sẽ được phục vụ bởi một nhân viên khác!",
        "staff_selected_by_customer": "Nhân viên được khách hàng lựa chọn",
        "staff-selection": "Lựa chọn nhân viên"
      }
    },
    "appointment-form-dialog": {
      "text": {
        "create_new_appointment": "Đặt lịch hẹn mới",
        "edit_appointment": "Thay đổi lịch hẹn"
      },
      "buttons": {
        "book": "ĐẶT",
        "close": "Quay lại",
        "save": "Lưu"
      }
    },
    "appointment-history-dialog": {
      "text": {
        "appointment_history": "Lịch hẹn vừa mới xem",
        "empty_history": "Lịch sử xem cuộc hẹn đang trống",
        "last_seen": "Lần cuối xem"
      }
    },
    "appointment-table": {
      "buttons": {
        "view": "Xem"
      },
      "text": {
        "all": "Tất cả",
        "customer": "Khách hàng",
        "date": "Ngày",
        "service": "Dịch vụ",
        "staff": "Nhân viên",
        "status": "Trạng thái"
      }
    },
    "available-date-selection-by-month": {
      "text": {
        "not-available": "Không khả dụng. Vui lòng chọn tháng khác!"
      }
    },
    "available-date-selection-by-serie": {
      "text": {
        "date_range": "Phạm vi ngày",
        "end_time": "Giờ kết thúc",
        "from_date": "Ngày bắt đầu",
        "start_time": "Giờ bắt đầu",
        "to_date": "Ngày kết thúc",
        "repeated_week_day": "Lặp lại vào các ngày trong tuần",
        "repeated_week_day_required": "Vui lòng chọn ít nhất một ngày trong tuần"
      }
    },
    "available-date-selection-form": {
      "text": {
        "date_selection": "Chọn ngày",
        "repeat_settings": "Cài đặt chu kỳ lặp lại",
        "unable_to_block": "Không thể tạo chặn lịch hẹn, vì salon sẽ đóng cửa hoặc đã có sẵn lịch hẹn/chặn lịch hẹn được đặt vào những ngày đã chọn"
      }
    },
    "available-slot-selection-by-date": {
      "text": {
        "afternoon": "BUỔI CHIỀU",
        "evening": "BUỔI TỐI",
        "morning": "BUỔI SÁNG",
        "not-available": "Không khả dụng. Vui lòng chọn ngày khác!"
      }
    },
    "available-slot-selection-by-week": {
      "text": {
        "not-available": "Không khả dụng. Vui lòng chọn một tuần khác!"
      }
    },
    "available-slot-selection-form": {
      "buttons": {
        "date-view": "Xem theo ngày",
        "week-view": "Xem theo tuần"
      },
      "text": {
        "date-time-selection": "Lựa chọn ngày giờ",
        "date-time-selection-hint": "Vui lòng chọn ít nhất một dịch vụ",
        "slot_tact": "Khoảng thời gian giữa các giờ hẹn",
        "slot_tact_example": {
          "5": "vd.: 09:00, 09:05, 09:10, 09:15, 09:20, v.v.",
          "15": "vd.: 09:00, 09:15, 09:30, 09:45, 10:00, v.v.",
          "30": "vd.: 09:00, 09:30, 10:00, 10:30, 11:00, v.v.",
          "60": "vd.: 09:00, 10:00, 11:00, 12:00, 13:00, v.v."
        }
      }
    },
    "blocker-deletion-dialog": {
      "buttons": {
        "delete": "Xóa"
      },
      "text": {
        "title": "Xóa chặn lịch hẹn",
        "delete_confirmation": "Bạn có chắc chắn muốn xóa chặn lịch này không? Chặn lịch hẹn sau khi xóa sẽ không thể khôi phục lại.",
        "delete_single_blocker_in_series": "Chỉ xóa chặn lịch này",
        "delete_series_blocker": "Xóa tất cả các chặn lịch hẹn trong chuỗi này",
        "delete_successfully": "Đã xóa thành công"
      }
    },
    "blocker-details-card": {
      "text": {
        "belong_to_series_blocker": "Chặn lịch hẹn này nằm trong một bộ chặn lịch hẹn định kỳ"
      }
    },
    "blocker-details-dialog": {
      "text": {
        "creation_time": "Ngày tạo",
        "last_update": "Cập nhật"
      },
      "buttons": {
        "back": "Quay lại",
        "edit": "Sửa chặn lịch hẹn",
        "delete": "Xóa chặn lịch hẹn"
      }
    },
    "blocker-form": {
      "text": {
        "all_day": "Chặn cả ngày",
        "duration": "Chặn lịch hẹn trong bao lâu",
        "off": "TẮT",
        "on": "BẬT",
        "reason": "Ghi chú",
        "reason_placeholder": "ví dụ. lý do chặn lịch hẹn",
        "series_blocker": "Chặn lịch hẹn định kỳ",
        "staff-selection": "Lựa chọn nhân viên"
      }
    },
    "blocker-form-dialog": {
      "text": {
        "blocker_updated": "Chặn lịch hẹn đã được cập nhật thành công",
        "create_new_blocker": "Tạo chặn lịch hẹn",
        "edit_blocker": "Sửa chặn lịch hẹn",
        "new_blocker_created": "Chặn lịch hẹn đã được tạo thành công",
        "new_serie_blocker_created": "Chặn lịch hẹn định kỳ đã được tạo thành công"
      },
      "buttons": {
        "close": "Quay lại",
        "create": "Tạo",
        "save": "Lưu"
      }
    },
    "business-notification-dialog": {
      "buttons": {
        "close": "Quay lại"
      },
      "text": {
        "no_notification": "Không có thông báo nào trong {{ day }} ngày qua",
        "notification": "Thông báo",
        "staff": "Nhân viên"
      }
    },
    "date-picker": {
      "current": {
        "agenda": "Tuần này",
        "day": "Hôm nay",
        "month": "Tháng này",
        "week": "Tuần này"
      }
    },
    "floating-buttons": {
      "buttons": {
        "new_appointment": "Đặt lịch",
        "new_blocker": "Chặn lịch"
      }
    },
    "quick-update-appointment-dialog": {
      "buttons": {
        "cancel": "Hủy bỏ",
        "confirm": "Xác nhận"
      },
      "text": {
        "original_appointment": "Lịch hẹn ban đầu",
        "original_blocker": "Chặn lịch hẹn ban đầu",
        "staff": "Nhân viên",
        "start_time": "Ngày và giờ",
        "update_unavailable": "Khoảng thời gian mong muốn không khả dụng!",
        "updated_confirmation": "Xác nhận cập nhật",
        "updated_successfully": "Đã cập nhật thành công!"
      }
    },
    "tool_bar": {
      "buttons": {
        "more": "Xem thêm",
        "view_appointment_history": "Lịch hẹn vừa mới xem",
        "view_cancelled_appointment": "Hiển thị lịch hẹn đã hủy"
      },
      "view_mode": {
        "agenda": "Danh sách",
        "day": "Theo ngày",
        "month": "Theo tháng",
        "week": "Theo tuần"
      }
    }
  }
}
